import { render, staticRenderFns } from "./funded-promotions-list-wrapper.vue?vue&type=template&id=3ea524e2&scoped=true"
import script from "./funded-promotions-list-wrapper.vue?vue&type=script&lang=js"
export * from "./funded-promotions-list-wrapper.vue?vue&type=script&lang=js"
import style0 from "./funded-promotions-list-wrapper.vue?vue&type=style&index=0&id=3ea524e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea524e2",
  null
  
)

export default component.exports